import { createApp } from 'vue'
import Cube from './Cube.vue'
import './assets/global.css'

createApp(Cube).mount('#cube')
